module.exports = __webpack_public_path__ + "static/media/overpass-extrabold-italic.cd4ba352.woff2";